function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowScrollDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 410.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow-scroll-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    points: "216 300.67 108 410.56 0 300.67 55.04 300.67 55.04 92.59 160.74 164.5 160.74 300.67 216 300.67",
    style: {
      fill: "#455465"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.68 151.27 54.98 79.27 54.98 60 113.2 99.61 160.68 131.91 160.68 151.27",
    style: {
      fill: "#4588aa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.68 121.27 54.98 49.27 54.98 30 160.68 101.91 160.68 121.27",
    style: {
      fill: "#4588aa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "160.68 91.27 54.98 19.27 54.98 0 160.68 71.91 160.68 91.27",
    style: {
      fill: "#4588aa"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowScrollDown);
export default __webpack_public_path__ + "static/media/arrow-scroll-down.512bb3015675f64c84182296ed5e153f.svg";
export { ForwardRef as ReactComponent };